import {ROOT_URL} from '../../config';
import request from '../../components/api/api';
import {gotLocations} from './actions';

export function getLocations(destinationId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/locations?_destId=${destinationId}`,
            method: 'GET',
        };

        return request(options, dispatch)
            .then(response => {
                dispatch(gotLocations(response.data));
            });
    }
}


// WEBPACK FOOTER //
// ./src/containers/locations/thunks.js